import React from "react";
import styled from "styled-components";

const LandingPage = () => {
  return <Container>LandingPage</Container>;
};
const Container = styled.div`
  padding: 7em;
`;

export default LandingPage;
